export const I18N_NAMESPACE = 'ankieter';
